import { render, staticRenderFns } from "./ModifyBackup.vue?vue&type=template&id=2b1436e3"
import script from "./ModifyBackup.vue?vue&type=script&lang=js"
export * from "./ModifyBackup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports